import conf from '../config';
import { md5 } from './utils';

const initialState = {
  user: null,
  organization: null,
  users: [],
};

const SET_USER = 'SET_USER';
const DELETE_USER = 'DELETE_USER';
const SET_USERS = 'SET_USERS';
const CLEAR_DATA = 'CLEAR_DATA';

export default (state = initialState, action) => {
  switch (action.type) {
    case SET_USER:
      const user = action.payload.user;
      if (user.gravatar) {
        const gravatar = user.gravatar.trim().toLowerCase();
        const hash = md5(gravatar);
        user.avatar = `https://www.gravatar.com/avatar/` + hash.toLowerCase();
      } else {
        user.avatar = '/img/avatar.png';
      }
      return {
        ...state,
        user: action.payload.user,
        organization: action.payload.organization,
      };
    case DELETE_USER:
      return { ...state, user: null, organization: null };
    case SET_USERS:
      return { ...state, users: action.payload };
    case CLEAR_DATA:
      return initialState;
    default:
      return state;
  }
};

export const authenticate = (username, password, organization) => {
  return async dispatch => {
    const result = await fetch(`${conf.apiRoot}/api/session`, {
      method: 'POST',
      credentials: 'include',
      headers: new Headers({
        'Content-Type': 'application/json',
      }),
      body: JSON.stringify({ username, password, organization: organization }),
    }).then(res => {
      if (res.status === 200) return res.json();
      return null;
    });
    if (result) dispatch(setUser(result.user, result.organization));
  };
};

export const authStatus = () => {
  return async dispatch => {
    try {
      const result = await fetch(`${conf.apiRoot}/api/session`, {
        credentials: 'include',
      }).then(res => {
        if (res.status === 200) return res.json();
        return null;
      });
      if (result) dispatch(setUser(result.user.user, result.user.organization));
      return result && result.user;
    } catch (e) {
      return null;
    }
  };
};

export const logout = () => {
  return async dispatch => {
    const user = await fetch(`${conf.apiRoot}/api/session`, {
      method: 'DELETE',
      credentials: 'include',
    }).then(res => res.json());
    if (user.status && user.status === 'success') {
      dispatch({ type: DELETE_USER });
      dispatch({ type: CLEAR_DATA });
    }
  };
};

export const fetchUsers = () => async (dispatch, getState) => {
  try {
    const state = getState();
    const users = getUsers(state);
    if (users.length) return users;
    const organization = getOrganization(state);
    if (!organization) return [];
    const result = await fetch(
      `${conf.apiRoot}/api/users?organization=${organization}`,
      {
        credentials: 'include',
      }
    ).then(res => {
      if (res.status === 200) return res.json();
      return null;
    });
    if (result) dispatch(setUsers(result.users));
    return result && result.user;
  } catch (e) {
    return null;
  }
};

export const getUser = state => state.users.user;
export const getUsers = state => state.users.users;
export const getOrganization = state => state.users.organization;
export const setUser = (user, organization) => {
  return dispatch =>
    dispatch({ type: SET_USER, payload: { user, organization } });
};

const setUsers = users => ({ type: SET_USERS, payload: users });

export const updateUser = data => async (dispatch, getState) => {
  const state = getState();
  const user = getUser(state);
  const username = user.username;
  const email = data.email;
  if (
    (user.emailsVerified && user.emailsVerified.length === 0) ||
    user.emailsVerified[0] !== email
  ) {
    data.newEmail = email;
  }

  const result = await fetch(`${conf.apiRoot}/api/users/${username}`, {
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json',
    },
    credentials: 'include',
    body: JSON.stringify(data),
  }).then(res => {
    if (res.status === 200) return res.json();
    return null;
  });
  if (result.status === 'ok') {
    dispatch(setUser(result.user.user, result.user.organization));
  }
  return result;
};



// WEBPACK FOOTER //
// ./src/modules/users.js